import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const useAdminAuth = (apiUrl, setProtect) => {
    const navigate = useNavigate();

    useEffect(() => {
        const checkAccess = async () => {
            const token = localStorage.getItem("token");

            if (!token) {
                navigate("/login", { replace: true });
                return;
            }

            try {
                const res = await axios.get(`${apiUrl}/profile`, {
                    headers: { Authorization: `Bearer ${token}` }
                });

                if (res.data.message === "Protected data") {
                    if (setProtect) setProtect(prev => prev + 2);
                } else {
                    navigate("/login", { replace: true });
                }
            } catch (err) {
                console.error("Auth check failed:", err);
                navigate("/login", { replace: true });
            }
        };

        checkAccess();

        const interval = setInterval(checkAccess, 10000);
        return () => clearInterval(interval);
    }, [apiUrl, navigate, setProtect]);
};

export default useAdminAuth;